import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserLastLoginCell} from './UserLastLoginCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import {UserInfoBox} from './UserInfoBox'

const usersColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    id: 'name',
    Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Email' className='min-w-125px' />,
    id: 'email',
    Cell: ({...props}) => <UserInfoBox userData={props.data[props.row.index].email} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Phone' className='min-w-125px' />,
    id: 'phone_number',
    Cell: ({...props}) => <UserInfoBox userData={props.data[props.row.index].phone_number} />,
  },  
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Role' className='min-w-125px' />,
    id: 'roleId',
    Cell: ({...props}) => <UserInfoBox userData={props.data[props.row.index].role.name} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Created At' className='min-w-125px' />,
    id: 'createdAt',
    Cell: ({...props}) => <UserInfoBox userData={props.data[props.row.index].createdAt.toLocaleString()} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Updated At' className='min-w-125px' />,
    id: 'updatedAt',
    Cell: ({...props}) => <UserInfoBox userData={props.data[props.row.index].updatedAt.toLocaleString()} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index].id} />,
  },
]

export {usersColumns}
